// src/App.tsx
import { Canvas } from "@react-three/fiber";
import { Route, Switch, Redirect } from "wouter";
import { Scene } from "./Scene";
import { pages, SPECIAL_PAGES } from "./data/pageData";
import { DefaultProjectPage } from "./pages/DefaultProjectPage";
import * as THREE from "three";
import { Suspense, useEffect, useRef, useState } from "react";
import { LoadingOverlay, SceneReady } from "./LoadingScreen";
import "./styles.css";
import { PageShell } from "./helpers/PageShell";
import { ProjectHud } from "./pages/ProjectHud";
import { DomainProvider, useDomain } from "./helpers/DomainContext";

export default function App() {
    return (
        <DomainProvider>
            <AppContent />
        </DomainProvider>
    );
}

function AppContent() {
    const { showPersonalInfo } = useDomain(); // HEY! Get outta here
    const [sceneReady, setSceneReady] = useState(false);

    useEffect(() => {
        if(showPersonalInfo) document.title = 'Ari Goldman'
    }, [])


    return (
        <>
            <LoadingOverlay isReady={sceneReady} />

            {/* 3D scene */}
            <div
                style={{
                    position: "fixed",
                    inset: 0,
                    zIndex: 0,
                    background:
                        "linear-gradient(to bottom, #4663ca, #4a84bf, #60b1bf)",
                }}
            >
                <Canvas
                    shadows={{ type: THREE.PCFSoftShadowMap }}
                    // camera={{ position: [25, 15, 25], fov: 60 }}
                    camera={{ position: [4, 4, 4], fov: 45 }}
                >
                    <Suspense fallback={null}>
                        <Scene />
                        <SceneReady onReady={() => setSceneReady(true)} />
                    </Suspense>
                </Canvas>
            </div>

            {/* html UI */}
            <Switch>
                {showPersonalInfo && (
                    <>
                        <Route path="/home">
                            <PageShell />
                        </Route>
                        <Route path="/resume">
                            <PageShell />
                        </Route>
                        <Route path="/contact">
                            <PageShell />
                        </Route>
                    </>
                )}

                <Route path="/projects">
                
                </Route>

                <Route path="/projects/:id?">
                    <ProjectHud />
                </Route>

                <Route path="/projects/:id/info">
                    {(params) => {
                        const id = params?.id;
                        const projectData = pages.find((p) => p.id === id);

                        if (!projectData) return <h1>Project Not Found</h1>;

                        const CustomComponent = SPECIAL_PAGES[id];

                        if (CustomComponent) {
                            return <CustomComponent />;
                        }

                        return <DefaultProjectPage project={projectData} />;
                    }}
                </Route>
                <Route>
                    <Redirect
                        to={showPersonalInfo ? "/home" : "/projects"}
                        replace
                    />
                </Route>
            </Switch>
        </>
    );
}
